// extracted by mini-css-extract-plugin
export default {"card":"bMhAl4L8v48gLOqrzNX_","statistic":"FwdylmZlVt1fGSm7IETe","greek-lang":"NEHYViFN500viSPk8vTq","divider":"MTw07RE4PQNMGHMJxgpL","button":"SxH1DS_x9JKPwyqqmAqv"};